import { API_endpoints } from "services/config";

export const getFutureHolydays = async (): Promise<any> => {
    try {
        const currentDate = new Date();
        const body = {
            start_date: currentDate.toISOString().split('T')[0],
        };

        const response = await fetch(API_endpoints.getFutureHolydays, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(body),
        });

        if (!response.ok) {
            throw new Error(`Fehler beim Laden von Feier Daten: ${response.status}`);
        }


        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Fehler beim Laden von Feier Daten:", error);
        throw error;
    }
};